import { render, staticRenderFns } from "./checkupItem.vue?vue&type=template&id=69a24519&scoped=true"
import script from "./checkupItem.vue?vue&type=script&lang=js"
export * from "./checkupItem.vue?vue&type=script&lang=js"
import style0 from "./checkupItem.vue?vue&type=style&index=0&id=69a24519&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a24519",
  null
  
)

export default component.exports